import instance from "./ApiConfig";
// import store from "../../Config/store.ts"; 

export const baseApiCall = async (config:any) => {
  try {

    const response = await instance(config);
    if (response?.status >= 200 && response?.status < 300) {
      return response?.data;
    } else {
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  } catch (e:any) {
    const errorMessage = e?.response?.data?.message || "An error occurred while making the request.";
    throw new Error(errorMessage);
  }
  finally{
  }
};
